import { render, staticRenderFns } from "./PendingReportsData.vue?vue&type=template&id=6ec3a6ea"
import script from "./PendingReportsData.vue?vue&type=script&lang=js"
export * from "./PendingReportsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports